const PRIORITY_LANGUAGES = {
  English: {
    displayName: "English",
    languageCode: "en",
    locale: "en-US",
    script: "Latin",
    direction: "ltr",
  },
  Indonesian: {
    displayName: "Indonesian",
    languageCode: "id",
    locale: "id-ID",
    script: "Latin",
    direction: "ltr",
  },
};

const byValue = Object.values(PRIORITY_LANGUAGES).reduce((result, language) => {
  result[language.displayName.toLowerCase()] = language;
  result[language.languageCode.toLowerCase()] = language;
  result[language.locale.toLowerCase()] = language;
  return result;
}, {});

export const normalizeInterviewLanguage = (value) => {
  const language = byValue[String(value || "English").trim().toLowerCase()];
  if (!language) {
    throw new Error(`Unsupported interview language: ${value}`);
  }
  return language;
};

export const getInterviewLanguage = (interview) => {
  if (interview?.language_code && interview?.locale && interview?.preferred_language) {
    return {
      displayName: interview.preferred_language,
      languageCode: interview.language_code,
      locale: interview.locale,
      script: interview.script || "Latin",
      direction: interview.direction || "ltr",
    };
  }
  return normalizeInterviewLanguage(
    interview?.preferred_language ||
      interview?.preferredLanguage ||
      interview?.locale ||
      interview?.language_code ||
      "English",
  );
};
